import { apiSdk } from '@/httpClient';
import React from 'react';
import Skeleton from 'react-loading-skeleton';

interface Props extends React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> {
  imageId: string;
}

export default function AuthImageById({ imageId, ...props }: Props) {
  const [src, setSrc] = React.useState<string>();
  React.useEffect(() => {
    apiSdk.AllowCacheService.downloadLandingSliderImage({ fileId: imageId }, { responseType: 'blob' }).then(res => {
      setSrc(window.URL.createObjectURL(new Blob([res])));
    });
  }, [imageId]);
  if (!src) {
    return <Skeleton {...props} style={{ minHeight: 200 }} />;
  }
  return <img {...props} src={src} />;
}
